import { PenIcon } from "assets/icons";
import { useBoolean } from "hooks";
import { t } from "i18next";
import moment from "moment";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { Button, IconButton, Input } from "ui";

import { useUpdateReseller } from "../../apis";
import { ResellerMainInfoProps } from "./ResellerMainInfo.types";

import styles from "./ResellerMainInfo.module.scss";

const ResellerMainInfo = ({ reseller }: ResellerMainInfoProps) => {
  const updateReseller = useUpdateReseller(reseller?.id, {
    onSuccess: () => {
      stopWelcomeCouponDiscountEditing();
      toast.success(t("Welcome Coupon Discount updated successfully"));
    }
  });

  const {
    value: isWelcomeCouponDiscountEditing,
    setTrue: startWelcomeCouponDiscountEditing,
    setFalse: stopWelcomeCouponDiscountEditing
  } = useBoolean(false);

  const [welcomeCouponDiscountToUpdate, setWelcomeCouponDiscountToUpdate] =
    useState<string>(String(reseller?.referralWelcomeCouponDiscountPercentage));

  useEffect(() => {
    setWelcomeCouponDiscountToUpdate(
      String(reseller?.referralWelcomeCouponDiscountPercentage)
    );
  }, [reseller?.referralWelcomeCouponDiscountPercentage]);

  return reseller ? (
    <div className={styles.mainInfo}>
      <div>
        <h4 className={styles.mainInfo_blockTitle}>{t("Phone Number")}</h4>
        {reseller.phoneNumber}
      </div>
      <div>
        <h4 className={styles.mainInfo_blockTitle}>
          {t("Mobile Money Number")}
        </h4>
        {reseller.mobileMoneyNumber ?? "-"}
      </div>
      <div>
        <h4 className={styles.mainInfo_blockTitle}>{t("Email")}</h4>
        {reseller.email ?? "-"}
      </div>
      <div>
        <h4 className={styles.mainInfo_blockTitle}>{t("Registration Date")}</h4>
        {moment(reseller.createdAt).format("DD MMM, YYYY ")}
      </div>
      <div>
        <h4 className={styles.mainInfo_blockTitle}>{t("Total Orders")}</h4>
        {reseller.totalNumberOfOrders}
      </div>
      <div>
        <h4 className={styles.mainInfo_blockTitle}>
          {t("Products Purchased")}
        </h4>
        {reseller.totalQuantityOfOrderedProducts}
      </div>
      <div>
        <h4 className={styles.mainInfo_blockTitle}>
          {t("Total Sales")} (FCFA)
        </h4>
        {reseller.totalSales.toLocaleString("en-US")}
      </div>
      <div>
        <h4 className={styles.mainInfo_blockTitle}>
          {t("Total Earnings")} (FCFA)
        </h4>
        {reseller.totalEarnings.toLocaleString("en-US")}
      </div>
      <div>
        <h4 className={styles.mainInfo_blockTitle}>
          {t("Commission Earned")} (FCFA)
        </h4>
        {reseller.totalCommission.toLocaleString("en-US")}
      </div>
      <div>
        <h4 className={styles.mainInfo_blockTitle}>
          {t("Margin Earned")} (FCFA)
        </h4>
        {reseller.totalMargin.toLocaleString("en-US")}
      </div>
      <div>
        <h4 className={styles.mainInfo_blockTitle}>
          {t("Welcome Coupon Discount")} (%)
        </h4>
        <div className={styles.mainInfo_welcomeCouponDiscountWrapper}>
          {isWelcomeCouponDiscountEditing ? (
            <>
              <Input
                value={welcomeCouponDiscountToUpdate}
                maxLength={2}
                min={95}
                type="number"
                onChange={(e) =>
                  setWelcomeCouponDiscountToUpdate(e.target.value)
                }
              />
              <Button
                size="sm"
                variant="primary"
                onClick={() => {
                  updateReseller.mutate({
                    resellerId: reseller.id,
                    referralWelcomeCouponDiscountPercentage:
                      +welcomeCouponDiscountToUpdate
                  });
                }}
              >
                {t("Save")}
              </Button>

              <Button
                size="sm"
                variant="default"
                onClick={() => {
                  stopWelcomeCouponDiscountEditing();
                  setWelcomeCouponDiscountToUpdate(
                    String(reseller?.referralWelcomeCouponDiscountPercentage)
                  );
                }}
              >
                {t("Cancel")}
              </Button>
            </>
          ) : (
            <>
              {reseller.referralWelcomeCouponDiscountPercentage}
              <IconButton
                icon={<PenIcon color="#fb3973" width={18} height={18} />}
                onClick={() => {
                  startWelcomeCouponDiscountEditing();
                }}
              />
            </>
          )}
        </div>
      </div>
    </div>
  ) : null;
};

export default ResellerMainInfo;
